import React from "react";
import { Link } from "react-router-dom";
import { Star } from "lucide-react";

export function formatINR(n) {
  if (n === undefined || n === null) return "—";
  return new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(n);
}

export default function ChefCard({ chef }) {
  const range = chef.salary_type === "international" ? "International Roster" : "India Roster";
  return (
    <Link
      to={`/chefs/${chef.id}`}
      data-testid={`chef-card-${chef.id}`}
      className="card-lux group block"
    >
      <div className="aspect-[4/5] overflow-hidden relative bg-neutral-900">
        <img
          src={chef.photo_url}
          alt={chef.name}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent" />
        <div className="absolute top-3 left-3">
          <span className="chip"><Star size={10} fill="#F5B041" stroke="#F5B041" /> {chef.rating}</span>
        </div>
        <div className="absolute top-3 right-3">
          <span className="chip text-[#F5B041]">{range}</span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-5">
          <div className="small-caps text-[10px] text-neutral-400 mb-1">{chef.cities?.join(" · ")}</div>
          <div className="font-serif-display text-2xl leading-tight">{chef.name}</div>
          <div className="text-neutral-300 text-sm mt-1">
            {chef.cuisines?.slice(0,3).join(" · ")}
          </div>
        </div>
      </div>
      <div className="p-5 flex items-center justify-between">
        <div>
          <div className="small-caps text-[10px] text-neutral-500">Monthly</div>
          <div className="font-serif-menu text-xl">₹{formatINR(chef.monthly_salary)}</div>
        </div>
        <div>
          <div className="small-caps text-[10px] text-neutral-500">Experience</div>
          <div className="font-serif-menu text-xl text-right">{chef.experience_yrs} yrs</div>
        </div>
      </div>
    </Link>
  );
}
